<template>
  <div>
    <img v-lazy="lazyLogo" class="logoWrapper" />
    <p>Link wird abgerufen.<br>Bitte habe einen Moment Geduld.</p>
    <div class="d-flex flex-row justify-content-center">
      <b-spinner></b-spinner>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Redirect',
  data() {
    return {
      lazyLogo: {
        src: 'logo.png',
        loading: 'logo-min.png',
      },
    };
  },
  created() {
    if (this.$route.params.code || this.$route.params.slug) this.getRedirect();
    else this.error('Kein Code angegeben');
  },
  methods: {
    getRedirect() {
      if (this.$route.params.code) {
        this.axios.get(`short/get?code=${this.$route.params.code}`)
          .then((res) => {
            window.location = res.data;
          })
          .catch(() => {
            this.error('Beim Abrufen ist ein Fehler aufgetreten');
          });
      } else if (this.$route.params.slug) {
        this.axios.get(`short/get?code=${this.$route.params.slug}&type=slug`)
          .then((res) => {
            window.location = res.data;
          })
          .catch(() => {
            this.error('Beim Abrufen ist ein Fehler aufgetreten');
          });
      } else {
        this.error('Kein Code angegeben');
      }
    },
  },
  computed: {
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
